export const SKILLS = [
  { category: 'Languages',        items: ['Python', 'TypeScript', 'JavaScript', 'Go'] },
  { category: 'Backend',          items: ['FastAPI', 'Django', 'NestJS', 'Flask', 'Starlette', 'Celery'] },
  { category: 'Frontend',         items: ['React', 'Next.js', 'Vue.js', 'Tailwind CSS', 'D3.js', 'Three.js'] },
  { category: 'Databases',        items: ['PostgreSQL', 'ClickHouse', 'Redis', 'MongoDB', 'Neo4j', 'MySQL'] },
  { category: 'AI & ML',          items: ['OpenAI / LLMs', 'Prompt Engineering', 'Time-Series Forecasting'] },
  { category: 'Protocols & APIs', items: ['REST', 'GraphQL', 'gRPC', 'WebSocket', 'Swagger / OpenAPI'] },
  { category: 'Testing & QA',     items: ['TDD', 'PyTest', 'E2E', 'Integration', 'Performance'] },
  { category: 'Cloud & DevOps',   items: ['AWS', 'Docker', 'Kubernetes', 'Terraform', 'CI/CD', 'Lambda'] },
  { category: 'Monitoring',       items: ['Prometheus', 'Grafana', 'OpenTelemetry', 'ELK Stack', 'Sentry'] },
  { category: 'Tools & Other',    items: ['Linux', 'Bash', 'Stripe', 'SQLAlchemy', 'OpenCV'] },
];
